<template>
  <portlet
      :actionsBlock="false"
      :icon="'fal fa-clock'"
      v-bind:class="showAnimation ? 'highlight-portlet' : ''"
      :title="getFormTitle"
  >
    <template slot="portletBody">
      <div class="shifts-form">
        <div class="row">
          <div class="col-12 col-md-9 col-lg-10 col-xl-11">
            <div class="form-group">
              <label for="shift-name">{{ $t('shifts.name') }}</label>
              <input type="text" v-validate="'required'" v-model="editingShift.name" class="form-control"
                     id="shift-name">
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2 col-xl-1">
            <div class="form-group">
              <label for="shift-name">{{ $t('shifts.code') }}</label>
              <input type="text" v-validate="'required'" v-model="editingShift.code" class="form-control"
                     id="shift-code">
            </div>
          </div>
          <div class="col">
            <div class="form-group"
            >
              <label for="shift-start-time">{{ $t('shifts.startTime') }}</label>
              <input
                  v-validate="{ is_not: editingShift.endTime}"
                  v-if="!editingShift.id"
                  id="shift-start-time"
                  type="time"
                  class="form-control"
                  v-model="editingShift.startTime"
              />
              <div class="disabled-times"  :data-toggle="'disabled-tooltip'" data-placement="top" :title="$t('shifts.disabledTimeChange')" v-else>
                {{ editingShift.startTime }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group"
            >
              <label for="shift-end-time">{{ $t('shifts.endTime') }}</label>
              <input
                  v-validate="{ is_not: editingShift.startTime}"
                  v-if="!editingShift.id"
                  id="shift-end-time"
                  type="time"
                  class="form-control"
                  @change="setRealEndTime"
                  v-model="formattedShiftEndTime"
              />
              <input
                  v-validate="{ is_not: editingShift.startTime}"
                  v-if="!editingShift.id"
                  id="shift-end-time-real"
                  type="hidden"
                  class="form-control"
                  v-model="editingShift.endTime"
              />
              <div  class="disabled-times"  :data-toggle="'disabled-tooltip'" data-placement="top" :title="$t('shifts.disabledTimeChange')" v-else>
                {{ formattedShiftEndTime }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2 col-xl-1">
            <label id="shift-color-label" for="shift-color">{{ $t('shifts.color') }}</label>
            <verte :colorHistory="defaultShiftColors" @input="setColor" :enableAlpha="false" :value="editingShift.color" :draggable="false" menuPosition="right" picker="square" model="hex"></verte>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-auto">
            <button id="dismiss-shift-changes-button" @click="dismissShiftEdit()"  class="mt-2 btn btn-primary">{{ $t('ui.cancel') }}</button>
          </div>
          <div class="col-12 col-sm-auto">
            <button id="save-shift-button" @click="saveShift()" class="mt-2 btn btn-primary">{{ $t('ui.save') }}</button>
          </div>
        </div>
      </div>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import {shiftFunctions} from "@/mixins/shifts/shiftFunctions";
import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
  name: "TeamsForm",
  props: ['originalEditingShift'],
  mixins: [ shiftFunctions ],
  data() {
    return {
      formattedShiftEndTime: null,
      editingShift: this.getEmptyShift(),
      showAnimation: false,
      defaultShiftColors: ['#8DA5E6', '#2A52BE', '#193172', '#7BEAE7', '#1CB1AD', '#116866 ']
    }
  },
  components: {
    Verte
  },
  computed: {
    ...mapGetters('users', [
      'getClaims'
    ]),
    getFormTitle() {
      return this.originalEditingShift ? this.$t('shifts.form.edit.title', {name: this.originalEditingShift.name}) : this.$t('shifts.form.create.title')
    }
  },
  methods: {
    setRealEndTime($event) {
      const realEndTime = moment().set({hour: parseInt(this.formattedShiftEndTime.split(':')[0]), minute: parseInt(this.formattedShiftEndTime.split(':')[1]) }).subtract(1, 'minute').format('HH:mm')
      this.editingShift.endTime = realEndTime;
    },
    getFormattedEndTime() {
      const formattedEndTime = moment().set({hour: parseInt(this.editingShift.endTime.split(':')[0]), minute: parseInt(this.editingShift.endTime.split(':')[1]) }).add(1, 'minute').format('HH:mm')
      this.formattedShiftEndTime = formattedEndTime;
    },
    setColor($event){
      this.editingShift.color = $event;
    },
    async saveShift() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        if (this.editingShift.id) {
          await this.$store.dispatch('shifts/patch', {...this.editingShift, companyId: this.getClaims.companyId});
        } else {
          await this.$store.dispatch('shifts/set', {...this.editingShift, companyId: this.getClaims.companyId});
        }
        this.dismissShiftEdit();
        this.$toasted.global.successRequest({
          message: this.$t('shifts.form.saved')
        });
      } else {
        this.$toasted.global.failedFormRequest();
      }
    },
    dismissShiftEdit() {
      this.$validator.reset()
      this.editingShift = this.getEmptyShift();
      this.$emit('clearOriginalEditingShift');
    },
    getEmptyShift() {
      return {
        id: '',
        name: '',
        code: '',
        color: '#2A52BE',
        startTime: '09:00',
        endTime: '17:00',
        activeFrom: null,
        deactivatedFrom: null,
        previousShiftId: null,
        includeInAvailability: true,
        includeInDashboards: true,
        includeInReportsIfEmpty: true,
        fakeShift: false
      };
    }
  },
  created() {
    $("body").tooltip({selector: '[data-toggle=disabled-tooltip]'});
  },
  watch: {
    originalEditingShift: {
      handler() {
        if (this.originalEditingShift) {
          this.showAnimation = true;
          this.editingShift = _.cloneDeep(this.originalEditingShift);
          this.getFormattedEndTime();
          setTimeout(() => { this.showAnimation = false; } , 1000)
        } else {
          this.editingShift = this.getEmptyShift();
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
#save-shift-button, #dismiss-shift-changes-button {
  width: 100%;
}


.highlight-portlet {
  animation: pulse; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 0.5s; /* don't forget to set a duration! */
}

.vertical-aligned-checkbox {
  display: grid;
  align-items: center;
}

.disabled-times {
  display: block;
  width: fit-content;
}
</style>
<style>
.verte__menu-origin {
  border: 1px solid #dbdbdb;
}

.verte__icon {
  cursor:  pointer;
}
</style>